module.exports = __webpack_public_path__ + "static/media/back-arrow-icon.b31312ac.svg";